import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mixit from './mixins/default.js';
import 'bootstrap/dist/js/bootstrap.js'

const app = createApp(App);

app.use(router);
app.use(store);
app.mixin(mixit);
app.mount('#app')
